import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { Player } from 'src/models/player.model';
import { UserService } from 'src/services/user.service';
import { Ladder } from '../../../models/ladder.model';
import { Score } from 'src/models/score.model';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'admin-set-rank',
  templateUrl: './setrank.component.html',
  styleUrls: ['setrank.component.scss']
})
export class AdminSetRankComponent implements OnInit {
  public busy: boolean = false;
  public players: Player[] = [];
  public ladders: Ladder[] = [];
  public ladderId: string;

  constructor(private authorizeService: AuthorizeService,
    private userSvc: UserService, private http: HttpClient,
    private routerLink: Router, private fb: FormBuilder) {
    this.busy = false;
  }

  ngOnInit(): void {
    this.queryPlayers(null);
    this.http.get<Ladder[]>('/ladders').subscribe(
      (resp) => {
        this.ladders = resp.map(l => new Ladder(l));
        this.ladders.unshift(new Ladder({ ladderId: null, name: 'Clear/Blank/Null' }))
      }
    );
  }

  private fetchPlayers(evt: any) {
    const x = this.ladderId;
    this.queryPlayers(this.ladderId);
  }

  // public asArray(f: any) {
  //   return f as FormArray;
  // }

  public form: FormArray = new FormArray([]);
  private queryPlayers(ladderId: string) {
    let url = `/admin/getallplayers`;
    let options = {};
    if (ladderId != null && ladderId != 'null') {
      //url += `?ladderId=${ladderId}`;
      let params = new HttpParams()
        .set('ladderId', ladderId)
      options = { params: params }
    }
    this.http.get<Player[]>(url, options).subscribe(
      (resp: Player[]) => {
        console.log(resp);
        //this.players.length = 0;
        for (let _p of resp) {
          //this.players.push(new Player(p));
          const p = new Player(_p);
          const g = this.fb.group({
            id: p.id,
            player: p,
            rank: new FormControl(p.rank)
          });
          this.form.push(g);
          // get notified of changing ranks
          g.valueChanges.subscribe((c) => { this.setRank(c.id, c.rank) });
        }
      }
    );
  }

  public setRank(userId: string, rank: string) {
    this.http.post<Player>('/admin/doSetRank', { userId, rank }).subscribe({
      next: () => {
        console.log('successfully updated player rank');
      },
      error: () => {
        console.error('failed updated player rank');
      }
    });
  }

  public showHistory(evt: any, userId: string) {
    evt.preventDefault();
    window.open(`/history?userId=${userId}`, '_blank');
  }

}
